import { useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "definitions/constants/routeConstants";
import apiClient from "services/ApiClient";
import { apiFormPathById } from "helpers/url/api/v2";
import { Form } from "./models";

export const formKeys = {
  all: ["forms"] as const,
  lists: () => [...formKeys.all, "list"] as const,
  list: (filters: string) => [...formKeys.lists(), { filters }] as const,
  details: () => [...formKeys.all, "detail"] as const,
  detail: (id: string) => [...formKeys.details(), id] as const,
};

export const useFormDetailQuery = (id: string, options = {}) => useQuery<Form>({
  queryKey: formKeys.detail(id),
  staleTime: 1000 * 60 * 20, // 3 minutes
  queryFn: async () => apiClient.get<Form>(apiFormPathById(id)),
  ...options,
});

export const useFormListQuery = (queryString?: string, options = {}) => useQuery<Form[]>({
  queryKey: queryString ? formKeys.list(queryString) : formKeys.lists(),
  staleTime: 1000 * 60 * 3, // 3 minutes
  queryFn: async () => apiClient.get<Form[]>(`${API_ROUTES.forms.index}${queryString ? `?${queryString}` : ""}`),
  ...options,
});
